import { ToastContainer } from "react-toastify";
import { useMediaQuery } from "../../Hooks/useMediaQuery";

// Phones get a compact card at the top, clear of the buy buttons, the WhatsApp
// button and the cookie banner at the bottom. The look lives in index.css (.app-toast).
const AppToastContainer = () => {
  // Same cut as react-toastify's own phone styles and the inset in index.css
  const isPhone = useMediaQuery("(max-width: 480px)");

  return (
    <ToastContainer
      position={isPhone ? "top-center" : "bottom-center"}
      autoClose={2500}
      hideProgressBar={isPhone}
      closeOnClick
      pauseOnHover={false}
      draggable
      theme="light"
      toastClassName={(context) =>
        `${context?.defaultClassName ?? "Toastify__toast"} app-toast app-toast--${context?.type ?? "default"}`
      }
    />
  );
};

export default AppToastContainer;
